import LogosBlock from './LogosBlock';

export default LogosBlock;
